import React from 'react';
import { FiSearch, FiMapPin } from 'react-icons/fi';
import { TRUCK_TYPES } from './utils/constants';

const SearchFilters = ({
  coords,
  geoError,
  sortBy,
  onSortChange,
  truckType,
  onTruckTypeChange,
  radiusKm,
  onRadiusChange,
  onSearch,
  loading
}) => {
  return (
    <div className="bg-gray-800/50 border border-gray-700 rounded-2xl shadow-lg p-6 space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div>
          <label className="block text-sm text-gray-400 mb-2">Votre position</label>
          {coords ? (
            <div className="text-sm font-mono flex items-center gap-1">
              <FiMapPin className="inline text-green-400" />
              {coords.lat.toFixed(3)}, {coords.lng.toFixed(3)}
            </div>
          ) : (
            <div className="text-sm text-gray-500">{geoError || "Localisation..."}</div>
          )}
        </div>
        
        <div>
          <label className="block text-sm text-gray-400 mb-2">Rayon de recherche</label>
          <div className="flex items-center gap-2">
            <input
              type="range"
              min="5"
              max="50"
              value={radiusKm}
              onChange={(e) => onRadiusChange(Number(e.target.value))}
              className="flex-1"
            />
            <span className="text-sm text-gray-300 w-12">{radiusKm} km</span>
          </div>
        </div>
        
        <div>
          <label className="block text-sm text-gray-400 mb-2">Tri par</label>
          <select 
            value={sortBy} 
            onChange={(e) => onSortChange(e.target.value)} 
            className="w-full bg-gray-700 border border-gray-600 rounded-lg p-2 focus:ring-amber-500 focus:border-amber-500 text-white"
          >
            <option value="distance">Distance</option>
            <option value="rating">Meilleure note</option>
            <option value="price">Prix</option>
          </select>
        </div>
        
        <div className="md:col-span-3 flex items-end">
          <button 
            onClick={onSearch} 
            disabled={loading || !coords} 
            className="w-full px-5 py-2.5 bg-amber-600 font-semibold rounded-lg hover:bg-amber-500 disabled:bg-gray-600 disabled:cursor-not-allowed flex items-center justify-center gap-2 transition-colors"
          >
            {loading ? (
              <div className="animate-spin h-5 w-5 border-2 border-white/50 border-t-white rounded-full"></div>
            ) : (
              <FiSearch className="w-5 h-5" />
            )}
            {loading ? "Recherche..." : "Rechercher"}
          </button>
        </div>
      </div>
      
      <div>
        <label className="block text-sm text-gray-400 mb-3">Type de camion</label>
        <div className="flex flex-wrap gap-2">
          <button 
            onClick={() => onTruckTypeChange("")} 
            className={`px-3 py-1.5 text-sm rounded-full border transition-colors ${
              truckType === "" 
                ? "bg-amber-500/20 text-amber-400 border-amber-500/30" 
                : "bg-gray-700 border-gray-600 hover:border-gray-500 text-gray-300"
            }`}
          >
            Tous
          </button>
          {Object.entries(TRUCK_TYPES).map(([truckTypeKey, meta]) => (
            <button 
              key={truckTypeKey} 
              onClick={() => onTruckTypeChange(truckTypeKey)} 
              className={`px-3 py-1.5 text-sm rounded-full border transition-colors ${
                truckType === truckTypeKey 
                  ? "bg-amber-500/20 text-amber-400 border-amber-500/30" 
                  : "bg-gray-700 border-gray-600 hover:border-gray-500 text-gray-300"
              }`}
              title={`Capacité: ${meta.volume} m³ — Équipe: ${meta.teamSize} pers.`}
            >
              {meta.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SearchFilters;





